
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphThemeGrid extends Serenity.EntityGrid<GraphThemeRow, any> {
        protected getColumnsKey() { return 'Visualizer.GraphTheme'; }
        protected getDialogType() { return GraphThemeDialog; }
        protected getIdProperty() { return GraphThemeRow.idProperty; }
        protected getLocalTextPrefix() { return GraphThemeRow.localTextPrefix; }
        protected getService() { return GraphThemeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}